// Seletores com busca nos cadastros: técnico (Contatos / Técnicos), cliente (Base clientes) e supervisor
// (usuários do Whaticket nas filas da área Supervisão de campo).
import React, { useEffect, useState } from "react";
import { TextField, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import suporteApi from "./api";

const useBusca = (url, extra = {}) => {
  const [texto, setTexto] = useState("");
  const [opcoes, setOpcoes] = useState([]);
  const chave = JSON.stringify(extra);
  useEffect(() => {
    const t = setTimeout(() => {
      suporteApi.get(url, { params: { busca: texto, por_pagina: 20, ...JSON.parse(chave) } })
        .then((r) => setOpcoes(r.data.itens || [])).catch(() => setOpcoes([]));
    }, 300);
    return () => clearTimeout(t);
  }, [url, texto, chave]);
  return [opcoes, setTexto];
};

export const rotuloTecnico = (t) => (t ? `QRA ${t.qra} · ${t.nome}${t.empresa ? ` (${t.empresa})` : ""}` : "");
export const rotuloCliente = (c) => (c ? `${c.conta} · ${c.nome}${c.cidade ? ` — ${c.cidade}` : ""}` : "");

export const SeletorTecnico = ({ value, onChange, label = "Técnico (cadastro)", id }) => {
  const [opcoes, setTexto] = useBusca("/api/tecnicos", { status: "ATIVO" });
  return (
    <Autocomplete id={id} value={value || null} options={opcoes} getOptionLabel={rotuloTecnico} filterOptions={(x) => x}
      getOptionSelected={(a, b) => a.id === b.id} onChange={(e, v) => onChange(v)} onInputChange={(e, v, motivo) => motivo === "input" && setTexto(v)}
      noOptionsText="Nenhum técnico encontrado" renderOption={(t) => (
        <div><div>{rotuloTecnico(t)}</div><Typography variant="caption" color="textSecondary">{t.telefone1 || "sem telefone"}</Typography></div>
      )}
      renderInput={(p) => <TextField {...p} label={label} size="small" variant="outlined" margin="dense" placeholder="QRA ou nome" />} />
  );
};

export const SeletorCliente = ({ value, onChange, label = "Cliente (Base clientes)", id }) => {
  const [opcoes, setTexto] = useBusca("/api/clientes");
  return (
    <Autocomplete id={id} value={value || null} options={opcoes} getOptionLabel={rotuloCliente} filterOptions={(x) => x}
      getOptionSelected={(a, b) => a.id === b.id} onChange={(e, v) => onChange(v)} onInputChange={(e, v, motivo) => motivo === "input" && setTexto(v)}
      noOptionsText="Nenhum cliente encontrado"
      renderInput={(p) => <TextField {...p} label={label} size="small" variant="outlined" margin="dense" placeholder="Conta, loja ou cidade" />} />
  );
};

export const SeletorSupervisor = ({ value, onChange, texto, onTexto, id }) => {
  const [info, setInfo] = useState(null);
  useEffect(() => { suporteApi.get("/api/supervisao/supervisores").then((r) => setInfo(r.data)).catch(() => setInfo({ configurado: false, usuarios: [] })); }, []);
  if (!info) return null;
  if (!info.configurado) {
    return (
      <TextField id={id} size="small" variant="outlined" margin="dense" fullWidth label="Supervisor" value={texto || ""}
        onChange={(e) => onTexto(e.target.value)}
        helperText="Configure a fila da Supervisão de campo em Administração → Áreas para escolher entre os usuários." />
    );
  }
  return (
    <Autocomplete id={id} value={info.usuarios.find((u) => u.id === value) || null} options={info.usuarios}
      getOptionLabel={(u) => u.nome} getOptionSelected={(a, b) => a.id === b.id} onChange={(e, v) => onChange(v)}
      noOptionsText={info.erro || "Nenhum usuário na fila da Supervisão"}
      renderInput={(p) => <TextField {...p} label="Supervisor (fila da Supervisão)" size="small" variant="outlined" margin="dense" />} />
  );
};
